const state = () => ({
  permissoes: [],
})
const getters = {
  temPermissaoSeguros(state) {
    return state.permissoes.some((item) => item.plataforma.id === 1);
  },
  temPermissaoFrota(state) {
    return state.permissoes.some((item) => item.plataforma.id === 2);
  }
}

const mutations = {
  setPermissoes(state, permissoes) {
    state.permissoes = permissoes
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/permissoes.js